var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFakturaoppsett = function SvgFakturaoppsett(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 42,
    x: 7,
    y: 3,
    className: "Fakturaoppsett_svg__FlowIcon",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 20a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2zm-11-6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm8-6a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2z",
    className: "Fakturaoppsett_svg__flowIconSnowStorm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 47c5.523 0 10-4.477 10-10a9.98 9.98 0 0 0-3.547-7.64A9.96 9.96 0 0 0 32 27c-5.523 0-10 4.477-10 10a9.99 9.99 0 0 0 4.332 8.24A9.95 9.95 0 0 0 32 47",
    className: "Fakturaoppsett_svg__flowIconReversed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.17 31 .203 1.674.707.277 1.322-.995 1.628 1.613-1.004 1.3.32.77 1.66.262v2.229l-1.66.249-.32.715 1.051 1.34-1.675 1.633-1.318-1.037-.711.298L33.166 43h-2.283l-.247-1.672-.704-.298-1.361 1.037-1.638-1.633 1.045-1.34-.315-.715-1.663-.25v-2.228l1.663-.262.315-.77-1.045-1.3 1.638-1.613 1.36.995.705-.277L30.88 31zM32 35a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    className: "Fakturaoppsett_svg__flowIconPrimary"
  }))));
};
export default SvgFakturaoppsett;